import flatten from 'lodash/flatten';

export const filterSectionsWithPictures = (sections = []) =>
  sections.filter((section) => section?.pictures);

// Crawls the Article for image URLs, to be used in structured data for Google.
// Returns them in string format, for use by <ArticleStructuredData /> component.
// --> '"image1.jpg", "image2.jpg", ...'
export const getImageSourcesForSEO = ({ sections }): string => {
  const sectionsWithPictures = filterSectionsWithPictures(sections);
  const pictures = flatten(sectionsWithPictures.map((section) => section.pictures));

  return pictures.map((picture) => `"${picture.url as string}"`).join(', ');
};
